import React from "react";
import formatDate from "utilities/formats/formatDate";
import { Table, Typography } from "antd";

const { Title } = Typography;
const ClinicRequests = ({ requestData }) => {
  const requestColumns = [
    {
      title: "Request Date",
      dataIndex: "requestDate",
      key: "requestDate",
      render: (text) => formatDate(text, "short"),
      width: 125,
    },
    {
      title: "Status",
      dataIndex: "currentStatus",
      //filters for Submitted, Approved, Shipped, Rejected, and Completed
      filters: [
        {
          text: "Submitted",
          value: "Submitted",
        },
        {
          text: "Approved",
          value: "Approved",
        },
        {
          text: "Shipped",
          value: "Shipped",
        },
        {
          text: "Rejected",
          value: "Rejected",
        },
        {
          text: "Completed",
          value: "Completed",
        },
      ],
      key: "currentStatus",
      onFilter: (value, record) => record.currentStatus.indexOf(value) === 0,
    },
    {
      title: "Request Type",
      dataIndex: "requestType",
      key: "requestType",
      //   filters for New Equipment, Transfer, and Repair
      filters: [
        {
          text: "New Equipment",
          value: "New Equipment",
        },
        {
          text: "Transfer",
          value: "Transfer",
        },
        {
          text: "Repair",
          value: "Repair",
        },
      ],
      onFilter: (value, record) => record.requestType.indexOf(value) === 0,
    },
    {
      title: "Requested By",
      dataIndex: "requestor",
      key: "requestor",
      render: (requestor) =>
        requestor.firstName +
        " " +
        requestor.lastName +
        " (" +
        requestor.initials +
        ")",
      width: "15%",
    },
    {
      title: "Category",
      dataIndex: ["equipment", "category"],
      key: "category",
    },
    {
      title: "Brand",
      dataIndex: ["equipment", "brand"],
      key: "brand",
    },
    {
      title: "Model",
      dataIndex: ["equipment", "model"],
      key: "model",
    },
  ];

  return (
    <>
      <Title level={4}>Equipment Requests</Title>
      <Table
        bordered
        columns={requestColumns}
        dataSource={requestData}
        pagination={{ pageSize: 10 }}
        sticky={true}
        size={"small"}
      />
    </>
  );
};

export default ClinicRequests;
